(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 35654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeRefs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};

function mergeRefs(refA, refB) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  return function (value) {
    if (a) a(value);
    if (b) b(value);
  };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */

function useMergedRefs(refA, refB) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return mergeRefs(refA, refB);
  }, [refA, refB]);
}

/* harmony default export */ __webpack_exports__["Z"] = (useMergedRefs);

/***/ }),

/***/ 52747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ dataProp; },
/* harmony export */   "PB": function() { return /* binding */ dataAttr; }
/* harmony export */ });
/* unused harmony exports ATTRIBUTE_PREFIX, PROPERTY_PREFIX */
const ATTRIBUTE_PREFIX = `data-rr-ui-`;
const PROPERTY_PREFIX = `rrUi`;
function dataAttr(property) {
  return `${ATTRIBUTE_PREFIX}${property}`;
}
function dataProp(property) {
  return `${PROPERTY_PREFIX}${property}`;
}

/***/ }),

/***/ 12963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindow; }
/* harmony export */ });
/* unused harmony export WindowProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23004);


const Context = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z ? window : undefined);
const WindowProvider = Context.Provider;

/**
 * The document "window" placed in React context. Helpful for determining
 * SSR context, or when rendering into an iframe.
 *
 * @returns the current window
 */
function useWindow() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
}

/***/ }),

/***/ 9351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports optionsSupported, onceSupported */
/* harmony import */ var _canUseDOM__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23004);
/* eslint-disable no-return-assign */

var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (_canUseDOM__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/* harmony default export */ __webpack_exports__["ZP"] = (addEventListener);

/***/ }),

/***/ 23004:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),

/***/ 90424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

/***/ }),

/***/ 72950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9351);
/* harmony import */ var _removeEventListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30099);



function listen(node, eventName, handler, options) {
  (0,_addEventListener__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(node, eventName, handler, options);
  return function () {
    (0,_removeEventListener__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node, eventName, handler, options);
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (listen);

/***/ }),

/***/ 67216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 60930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ qsa; }
/* harmony export */ });
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}

/***/ }),

/***/ 30099:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

/* harmony default export */ __webpack_exports__["Z"] = (removeEventListener);

/***/ }),

/***/ 86008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(72181);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52681);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15094);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35005);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4492);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34051);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63372);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46737);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(sweetalert__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81288);
/* harmony import */ var react_country_flag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99318);














const Contact = ()=>{
    // State variables to store form data
    const [name, setName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [phone, setPhone] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [city, setCity] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [subject, setSubject] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [message, setMessage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [country, setcountry] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [countrycc, setcountrycc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    const [indianStates, setIndianStates] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar Islands",
        "Chandigarh",
        "Dadra and Nagar Haveli",
        "Daman and Diu",
        "Lakshadweep",
        "Delhi",
        "Puducherry"
    ]);
    const countries = [
        {
            name: "Afghanistan",
            code: "93",
            cc: "AF"
        },
        {
            name: "Albania",
            code: "355",
            cc: "AL"
        },
        {
            name: "Algeria",
            code: "213",
            cc: "DZ"
        },
        {
            name: "American Samoa",
            code: "1-684",
            cc: "AS"
        },
        {
            name: "Andorra",
            code: "376",
            cc: "AD"
        },
        {
            name: "Angola",
            code: "244",
            cc: "AO"
        },
        {
            name: "Anguilla",
            code: "1-264",
            cc: "AI"
        },
        {
            name: "Antarctica",
            code: "672",
            cc: "AQ"
        },
        {
            name: "Antigua and Barbuda",
            code: "1-268",
            cc: "AG"
        },
        {
            name: "Argentina",
            code: "54",
            cc: "AR"
        },
        {
            name: "Armenia",
            code: "374",
            cc: "AM"
        },
        {
            name: "Aruba",
            code: "297",
            cc: "AW"
        },
        {
            name: "Australia",
            code: "61",
            cc: "AU"
        },
        {
            name: "Austria",
            code: "43",
            cc: "AT"
        },
        {
            name: "Azerbaijan",
            code: "994",
            cc: "AZ"
        },
        {
            name: "Bahamas",
            code: "1-242",
            cc: "BS"
        },
        {
            name: "Bahrain",
            code: "973",
            cc: "BH"
        },
        {
            name: "Bangladesh",
            code: "880",
            cc: "BD"
        },
        {
            name: "Barbados",
            code: "1-246",
            cc: "BB"
        },
        {
            name: "Belarus",
            code: "375",
            cc: "BY"
        },
        {
            name: "Belgium",
            code: "32",
            cc: "BE"
        },
        {
            name: "Belize",
            code: "501",
            cc: "BZ"
        },
        {
            name: "Benin",
            code: "229",
            cc: "BJ"
        },
        {
            name: "Bermuda",
            code: "1-441",
            cc: "BM"
        },
        {
            name: "Bhutan",
            code: "975",
            cc: "BT"
        },
        {
            name: "Bolivia",
            code: "591",
            cc: "BO"
        },
        {
            name: "Bosnia and Herzegovina",
            code: "387",
            cc: "BA"
        },
        {
            name: "Botswana",
            code: "267",
            cc: "BW"
        },
        {
            name: "Brazil",
            code: "55",
            cc: "BR"
        },
        {
            name: "British Indian Ocean Territory",
            code: "246",
            cc: "IO"
        },
        {
            name: "British Virgin Islands",
            code: "1-284",
            cc: "VG"
        },
        {
            name: "Brunei",
            code: "673",
            cc: "BN"
        },
        {
            name: "Bulgaria",
            code: "359",
            cc: "BG"
        },
        {
            name: "Burkina Faso",
            code: "226",
            cc: "BF"
        },
        {
            name: "Burundi",
            code: "257",
            cc: "BI"
        },
        {
            name: "Cambodia",
            code: "855",
            cc: "KH"
        },
        {
            name: "Cameroon",
            code: "237",
            cc: "CM"
        },
        {
            name: "Canada",
            code: "1",
            cc: "CA"
        },
        {
            name: "Cape Verde",
            code: "238",
            cc: "CV"
        },
        {
            name: "Cayman Islands",
            code: "1-345",
            cc: "KY"
        },
        {
            name: "Central African Republic",
            code: "236",
            cc: "CF"
        },
        {
            name: "Chad",
            code: "235",
            cc: "TD"
        },
        {
            name: "Chile",
            code: "56",
            cc: "CL"
        },
        {
            name: "China",
            code: "86",
            cc: "CN"
        },
        {
            name: "Christmas Island",
            code: "61",
            cc: "CX"
        },
        {
            name: "Cocos Islands",
            code: "61",
            cc: "CC"
        },
        {
            name: "Colombia",
            code: "57",
            cc: "CO"
        },
        {
            name: "Comoros",
            code: "269",
            cc: "KM"
        },
        {
            name: "Cook Islands",
            code: "682",
            cc: "CK"
        },
        {
            name: "Costa Rica",
            code: "506",
            cc: "CR"
        },
        {
            name: "Croatia",
            code: "385",
            cc: "HR"
        },
        {
            name: "Cuba",
            code: "53",
            cc: "CU"
        },
        {
            name: "Curacao",
            code: "599",
            cc: "CW"
        },
        {
            name: "Cyprus",
            code: "357",
            cc: "CY"
        },
        {
            name: "Czech Republic",
            code: "420",
            cc: "CZ"
        },
        {
            name: "Democratic Republic of the Congo",
            code: "243",
            cc: "CD"
        },
        {
            name: "Denmark",
            code: "45",
            cc: "DK"
        },
        {
            name: "Djibouti",
            code: "253",
            cc: "DJ"
        },
        {
            name: "Dominica",
            code: "1-767",
            cc: "DM"
        },
        {
            name: "Dominican Republic",
            code: "1-809, 1-829, 1-849",
            cc: "DO"
        },
        {
            name: "East Timor",
            code: "670",
            cc: "TL"
        },
        {
            name: "Ecuador",
            code: "593",
            cc: "EC"
        },
        {
            name: "Egypt",
            code: "20",
            cc: "EG"
        },
        {
            name: "El Salvador",
            code: "503",
            cc: "SV"
        },
        {
            name: "Equatorial Guinea",
            code: "240",
            cc: "GQ"
        },
        {
            name: "Eritrea",
            code: "291",
            cc: "ER"
        },
        {
            name: "Estonia",
            code: "372",
            cc: "EE"
        },
        {
            name: "Ethiopia",
            code: "251",
            cc: "ET"
        },
        {
            name: "Falkland Islands",
            code: "500",
            cc: "FK"
        },
        {
            name: "Faroe Islands",
            code: "298",
            cc: "FO"
        },
        {
            name: "Fiji",
            code: "679",
            cc: "FJ"
        },
        {
            name: "Finland",
            code: "358",
            cc: "FI"
        },
        {
            name: "France",
            code: "33",
            cc: "FR"
        },
        {
            name: "French Polynesia",
            code: "689",
            cc: "PF"
        },
        {
            name: "Gabon",
            code: "241",
            cc: "GA"
        },
        {
            name: "Gambia",
            code: "220",
            cc: "GM"
        },
        {
            name: "Georgia",
            code: "995",
            cc: "GE"
        },
        {
            name: "Germany",
            code: "49",
            cc: "DE"
        },
        {
            name: "Ghana",
            code: "233",
            cc: "GH"
        },
        {
            name: "Gibraltar",
            code: "350",
            cc: "GI"
        },
        {
            name: "Greece",
            code: "30",
            cc: "GR"
        },
        {
            name: "Greenland",
            code: "299",
            cc: "GL"
        },
        {
            name: "Grenada",
            code: "1-473",
            cc: "GD"
        },
        {
            name: "Guam",
            code: "1-671",
            cc: "GU"
        },
        {
            name: "Guatemala",
            code: "502",
            cc: "GT"
        },
        {
            name: "Guernsey",
            code: "44-1481",
            cc: "GG"
        },
        {
            name: "Guinea",
            code: "224",
            cc: "GN"
        },
        {
            name: "Guinea-Bissau",
            code: "245",
            cc: "GW"
        },
        {
            name: "Guyana",
            code: "592",
            cc: "GY"
        },
        {
            name: "Haiti",
            code: "509",
            cc: "HT"
        },
        {
            name: "Honduras",
            code: "504",
            cc: "HN"
        },
        {
            name: "Hong Kong",
            code: "852",
            cc: "HK"
        },
        {
            name: "Hungary",
            code: "36",
            cc: "HU"
        },
        {
            name: "Iceland",
            code: "354",
            cc: "IS"
        },
        {
            name: "India",
            code: "91",
            cc: "IN"
        },
        {
            name: "Indonesia",
            code: "62",
            cc: "ID"
        },
        {
            name: "Iran",
            code: "98",
            cc: "IR"
        },
        {
            name: "Iraq",
            code: "964",
            cc: "IQ"
        },
        {
            name: "Ireland",
            code: "353",
            cc: "IE"
        },
        {
            name: "Isle of Man",
            code: "44-1624",
            cc: "IM"
        },
        {
            name: "Israel",
            code: "972",
            cc: "IL"
        },
        {
            name: "Italy",
            code: "39",
            cc: "IT"
        },
        {
            name: "Ivory Coast",
            code: "225",
            cc: "CI"
        },
        {
            name: "Jamaica",
            code: "1-876",
            cc: "JM"
        },
        {
            name: "Japan",
            code: "81",
            cc: "JP"
        },
        {
            name: "Jersey",
            code: "44-1534",
            cc: "JE"
        },
        {
            name: "Jordan",
            code: "962",
            cc: "JO"
        },
        {
            name: "Kazakhstan",
            code: "7",
            cc: "KZ"
        },
        {
            name: "Kenya",
            code: "254",
            cc: "KE"
        },
        {
            name: "Kiribati",
            code: "686",
            cc: "KI"
        },
        {
            name: "Kosovo",
            code: "383",
            cc: "XK"
        },
        {
            name: "Kuwait",
            code: "965",
            cc: "KW"
        },
        {
            name: "Kyrgyzstan",
            code: "996",
            cc: "KG"
        },
        {
            name: "Laos",
            code: "856",
            cc: "LA"
        },
        {
            name: "Latvia",
            code: "371",
            cc: "LV"
        },
        {
            name: "Lebanon",
            code: "961",
            cc: "LB"
        },
        {
            name: "Lesotho",
            code: "266",
            cc: "LS"
        },
        {
            name: "Liberia",
            code: "231",
            cc: "LR"
        },
        {
            name: "Libya",
            code: "218",
            cc: "LY"
        },
        {
            name: "Liechtenstein",
            code: "423",
            cc: "LI"
        },
        {
            name: "Lithuania",
            code: "370",
            cc: "LT"
        },
        {
            name: "Luxembourg",
            code: "352",
            cc: "LU"
        },
        {
            name: "Macau",
            code: "853",
            cc: "MO"
        },
        {
            name: "Macedonia",
            code: "389",
            cc: "MK"
        },
        {
            name: "Madagascar",
            code: "261",
            cc: "MG"
        },
        {
            name: "Malawi",
            code: "265",
            cc: "MW"
        },
        {
            name: "Malaysia",
            code: "60",
            cc: "MY"
        },
        {
            name: "Maldives",
            code: "960",
            cc: "MV"
        },
        {
            name: "Mali",
            code: "223",
            cc: "ML"
        },
        {
            name: "Malta",
            code: "356",
            cc: "MT"
        },
        {
            name: "Marshall Islands",
            code: "692",
            cc: "MH"
        },
        {
            name: "Mauritania",
            code: "222",
            cc: "MR"
        },
        {
            name: "Mauritius",
            code: "230",
            cc: "MU"
        },
        {
            name: "Mayotte",
            code: "262",
            cc: "YT"
        },
        {
            name: "Mexico",
            code: "52",
            cc: "MX"
        },
        {
            name: "Micronesia",
            code: "691",
            cc: "FM"
        },
        {
            name: "Moldova",
            code: "373",
            cc: "MD"
        },
        {
            name: "Monaco",
            code: "377",
            cc: "MC"
        },
        {
            name: "Mongolia",
            code: "976",
            cc: "MN"
        },
        {
            name: "Montenegro",
            code: "382",
            cc: "ME"
        },
        {
            name: "Montserrat",
            code: "1-664",
            cc: "MS"
        },
        {
            name: "Morocco",
            code: "212",
            cc: "MA"
        },
        {
            name: "Mozambique",
            code: "258",
            cc: "MZ"
        },
        {
            name: "Myanmar",
            code: "95",
            cc: "MM"
        },
        {
            name: "Namibia",
            code: "264",
            cc: "NA"
        },
        {
            name: "Nauru",
            code: "674",
            cc: "NR"
        },
        {
            name: "Nepal",
            code: "977",
            cc: "NP"
        },
        {
            name: "Netherlands",
            code: "31",
            cc: "NL"
        },
        {
            name: "Netherlands Antilles",
            code: "599",
            cc: "AN"
        },
        {
            name: "New Caledonia",
            code: "687",
            cc: "NC"
        },
        {
            name: "New Zealand",
            code: "64",
            cc: "NZ"
        },
        {
            name: "Nicaragua",
            code: "505",
            cc: "NI"
        },
        {
            name: "Niger",
            code: "227",
            cc: "NE"
        },
        {
            name: "Nigeria",
            code: "234",
            cc: "NG"
        },
        {
            name: "Niue",
            code: "683",
            cc: "NU"
        },
        {
            name: "North Korea",
            code: "850",
            cc: "KP"
        },
        {
            name: "Northern Mariana Islands",
            code: "1-670",
            cc: "MP"
        },
        {
            name: "Norway",
            code: "47",
            cc: "NO"
        },
        {
            name: "Oman",
            code: "968",
            cc: "OM"
        },
        {
            name: "Pakistan",
            code: "92",
            cc: "PK"
        },
        {
            name: "Palau",
            code: "680",
            cc: "PW"
        },
        {
            name: "Palestine",
            code: "970",
            cc: "PS"
        },
        {
            name: "Panama",
            code: "507",
            cc: "PA"
        },
        {
            name: "Papua New Guinea",
            code: "675",
            cc: "PG"
        },
        {
            name: "Paraguay",
            code: "595",
            cc: "PY"
        },
        {
            name: "Peru",
            code: "51",
            cc: "PE"
        },
        {
            name: "Philippines",
            code: "63",
            cc: "PH"
        },
        {
            name: "Pitcairn",
            code: "64",
            cc: "PN"
        },
        {
            name: "Poland",
            code: "48",
            cc: "PL"
        },
        {
            name: "Portugal",
            code: "351",
            cc: "PT"
        },
        {
            name: "Puerto Rico",
            code: "1-787, 1-939",
            cc: "PR"
        },
        {
            name: "Qatar",
            code: "974",
            cc: "QA"
        },
        {
            name: "Republic of the Congo",
            code: "242",
            cc: "CG"
        },
        {
            name: "Reunion",
            code: "262",
            cc: "RE"
        },
        {
            name: "Romania",
            code: "40",
            cc: "RO"
        },
        {
            name: "Russia",
            code: "7",
            cc: "RU"
        },
        {
            name: "Rwanda",
            code: "250",
            cc: "RW"
        },
        {
            name: "Saint Barthelemy",
            code: "590",
            cc: "BL"
        },
        {
            name: "Saint Helena",
            code: "290",
            cc: "SH"
        },
        {
            name: "Saint Kitts and Nevis",
            code: "1-869",
            cc: "KN"
        },
        {
            name: "Saint Lucia",
            code: "1-758",
            cc: "LC"
        },
        {
            name: "Saint Martin",
            code: "590",
            cc: "MF"
        },
        {
            name: "Saint Pierre and Miquelon",
            code: "508",
            cc: "PM"
        },
        {
            name: "Saint Vincent and the Grenadines",
            code: "1-784",
            cc: "VC"
        },
        {
            name: "Samoa",
            code: "685",
            cc: "WS"
        },
        {
            name: "San Marino",
            code: "378",
            cc: "SM"
        },
        {
            name: "Sao Tome and Principe",
            code: "239",
            cc: "ST"
        },
        {
            name: "Saudi Arabia",
            code: "966",
            cc: "SA"
        },
        {
            name: "Senegal",
            code: "221",
            cc: "SN"
        },
        {
            name: "Serbia",
            code: "381",
            cc: "RS"
        },
        {
            name: "Seychelles",
            code: "248",
            cc: "SC"
        },
        {
            name: "Sierra Leone",
            code: "232",
            cc: "SL"
        },
        {
            name: "Singapore",
            code: "65",
            cc: "SG"
        },
        {
            name: "Sint Maarten",
            code: "1-721",
            cc: "SX"
        },
        {
            name: "Slovakia",
            code: "421",
            cc: "SK"
        },
        {
            name: "Slovenia",
            code: "386",
            cc: "SI"
        },
        {
            name: "Solomon Islands",
            code: "677",
            cc: "SB"
        },
        {
            name: "Somalia",
            code: "252",
            cc: "SO"
        },
        {
            name: "South Africa",
            code: "27",
            cc: "ZA"
        },
        {
            name: "South Korea",
            code: "82",
            cc: "KR"
        },
        {
            name: "South Sudan",
            code: "211",
            cc: "SS"
        },
        {
            name: "Spain",
            code: "34",
            cc: "ES"
        },
        {
            name: "Sri Lanka",
            code: "94",
            cc: "LK"
        },
        {
            name: "Sudan",
            code: "249",
            cc: "SD"
        },
        {
            name: "Suriname",
            code: "597",
            cc: "SR"
        },
        {
            name: "Svalbard and Jan Mayen",
            code: "47",
            cc: "SJ"
        },
        {
            name: "Swaziland",
            code: "268",
            cc: "SZ"
        },
        {
            name: "Sweden",
            code: "46",
            cc: "SE"
        },
        {
            name: "Switzerland",
            code: "41",
            cc: "CH"
        },
        {
            name: "Syria",
            code: "963",
            cc: "SY"
        },
        {
            name: "Taiwan",
            code: "886",
            cc: "TW"
        },
        {
            name: "Tajikistan",
            code: "992",
            cc: "TJ"
        },
        {
            name: "Tanzania",
            code: "255",
            cc: "TZ"
        },
        {
            name: "Thailand",
            code: "66",
            cc: "TH"
        },
        {
            name: "Togo",
            code: "228",
            cc: "TG"
        },
        {
            name: "Tokelau",
            code: "690",
            cc: "TK"
        },
        {
            name: "Tonga",
            code: "676",
            cc: "TO"
        },
        {
            name: "Trinidad and Tobago",
            code: "1-868",
            cc: "TT"
        },
        {
            name: "Tunisia",
            code: "216",
            cc: "TN"
        },
        {
            name: "Turkey",
            code: "90",
            cc: "TR"
        },
        {
            name: "Turkmenistan",
            code: "993",
            cc: "TM"
        },
        {
            name: "Turks and Caicos Islands",
            code: "1-649",
            cc: "TC"
        },
        {
            name: "Tuvalu",
            code: "688",
            cc: "TV"
        },
        {
            name: "U.S. Virgin Islands",
            code: "1-340",
            cc: "VI"
        },
        {
            name: "Uganda",
            code: "256",
            cc: "UG"
        },
        {
            name: "Ukraine",
            code: "380",
            cc: "UA"
        },
        {
            name: "United Arab Emirates",
            code: "971",
            cc: "AE"
        },
        {
            name: "United Kingdom",
            code: "44",
            cc: "GB"
        },
        {
            name: "United States",
            code: "1",
            cc: "US"
        },
        {
            name: "Uruguay",
            code: "598",
            cc: "UY"
        },
        {
            name: "Uzbekistan",
            code: "998",
            cc: "UZ"
        },
        {
            name: "Vanuatu",
            code: "678",
            cc: "VU"
        },
        {
            name: "Vatican",
            code: "379",
            cc: "VA"
        },
        {
            name: "Venezuela",
            code: "58",
            cc: "VE"
        },
        {
            name: "Vietnam",
            code: "84",
            cc: "VN"
        },
        {
            name: "Wallis and Futuna",
            code: "681",
            cc: "WF"
        },
        {
            name: "Western Sahara",
            code: "212",
            cc: "EH"
        },
        {
            name: "Yemen",
            code: "967",
            cc: "YE"
        },
        {
            name: "Zambia",
            code: "260",
            cc: "ZM"
        },
        {
            name: "Zimbabwe",
            code: "263",
            cc: "ZW"
        }
    ];
    const addtoanalytics = async ()=>{
        var ref, ref1;
        let ipInfo = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://obl-js.orientbell.com/api/ipinfo");
        if ((ref = ipInfo.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.country) {
            var ref2, ref3, ref4, ref5;
            const selectedCountry = countries.find((country)=>{
                var ref, ref1;
                return country.name === ((ref = ipInfo.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.country);
            });
            setcountry((ref2 = ipInfo.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.response) === null || ref3 === void 0 ? void 0 : ref3.country);
            setcountrycc(selectedCountry ? selectedCountry.cc : "");
            // setcountry(ipInfo.data?.response?.country)
            await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].post */ .Z.post("https://proxy.orientbell.com/api/countrydata", {
                country: (ref4 = ipInfo.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.response) === null || ref5 === void 0 ? void 0 : ref5.country
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isMounted.current) {
            addtoanalytics();
            isMounted.current = true;
        }
    }, []);
    // Function to handle form submission
    const handleSubmit = async (e)=>{
        e.preventDefault();
        // gtagConversionEvent()
        setLoading(true);
        const selectedCountry = countries.find((countryy)=>countryy.name === country);
        console.log(selectedCountry);
        let response = await (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_2__/* .contactUs */ .hz)({
            name,
            phone: "+".concat(selectedCountry.code, " ").concat(phone),
            state,
            city,
            subject,
            email,
            message,
            country
        });
        if (response.message) {
            sweetalert__WEBPACK_IMPORTED_MODULE_3___default()(response.message);
            setLoading(false);
        } else {
            sweetalert__WEBPACK_IMPORTED_MODULE_3___default()(response.data.contact_us.msg);
            setLoading(false);
            setMessage("");
            setEmail("");
            setSubject("");
            setCity("");
            setState("");
            setPhone("");
            setName("");
            setcountry("");
        }
    };
    const breadCrumbSchema = ()=>{
        return {
            __html: '{\n        "@context": "https://schema.org/", \n        "@type": "BreadcrumbList", \n        "itemListElement": [{\n          "@type": "ListItem", \n          "position": 1, \n          "name": "Home",\n          "item": "https://www.orientbell.com"\n        },{\n        "@type": "ListItem", \n        "position": 2, \n        "name": "Contact Us",\n        "item": "https://obl-new.orientbell.com/contact-us"\n      }]\n      }'
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Contact Us - Corporate Office | Orientbell Tiles"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "Contact Us - Corporate Office | Orientbell Tiles"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Contact Orientbell for sales queries, feedback or inquiries about the ceramic & vitrified tiles. Find Orientbell's corporate office address and toll-free number."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "orientbell contact, contact orientbell, orientbell enquiries, orientbell contact information"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: breadCrumbSchema()
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "contactus_page",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    href: "https://obl-new.orientbell.com/",
                                    children: "Home"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    href: "#",
                                    children: "Contact Us"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "The Orientbell Tile store is a one-stop-solution for all your tiling needs in ceramic and vitrified tiles. With an incredible range of floor and wall tiles, this is indeed one of the best tile shops that allow you to select the perfect tiles for your home and offices. You can now visualize your space with your preferred tile designs for free by using quicklook tool available at Orientbell Tile boutiques and choose the tiling options best suited for your style, budget, and other preferences at the tile showroom near you. Shopping for tiles was never this easy and hassle-free."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "contactus_data",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "contactus_data_con",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        onSubmit: handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                        className: "mb-3",
                                                        as: react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
                                                        lg: "6",
                                                        controlId: "validationCustom01",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                                children: "Your Name"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                                type: "text",
                                                                placeholder: "Full Name",
                                                                value: name,
                                                                onChange: (e)=>setName(e.target.value),
                                                                required: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                        className: "mb-3",
                                                        as: react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
                                                        lg: "6",
                                                        controlId: "validationCustom02",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                                children: "Contact Number"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                                type: "number",
                                                                inputMode: "numeric",
                                                                pattern: "[0-9]{10}",
                                                                placeholder: "Your Contact",
                                                                value: phone,
                                                                onChange: (e)=>setPhone(e.target.value),
                                                                required: true,
                                                                onInput: (e)=>{
                                                                    const value = e.target.value;
                                                                    if (!/^\d{10,13}$/.test(value)) {
                                                                        e.target.setCustomValidity("Please enter a mobile number between 10 to 13 digits.");
                                                                    } else {
                                                                        e.target.setCustomValidity("");
                                                                    }
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mb-3 country-number-row",
                                                    lg: "12",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                            children: "Country"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                            className: "mb-3",
                                                            as: react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
                                                            lg: "12",
                                                            controlId: "validationCustom01",
                                                            onSelect: (selectedCountryCode)=>{
                                                                const selectedCountry = countries.find((country)=>country.code === selectedCountryCode);
                                                                setcountry(selectedCountry.name);
                                                                setcountrycc(selectedCountry ? selectedCountry.cc : "");
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Toggle */ .Z.Toggle, {
                                                                    variant: "secondary",
                                                                    id: "dropdown-basic",
                                                                    children: [
                                                                        country && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_country_flag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                                    countryCode: countrycc,
                                                                                    svg: true
                                                                                }),
                                                                                " (".concat(country, ")")
                                                                            ]
                                                                        }),
                                                                        !country && "Country Code"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Menu */ .Z.Menu, {
                                                                    style: {
                                                                        maxHeight: "200px",
                                                                        overflowY: "auto"
                                                                    },
                                                                    children: countries.map((country)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Item */ .Z.Item, {
                                                                            eventKey: country.code,
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_country_flag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                                        countryCode: country.cc,
                                                                                        svg: true
                                                                                    }),
                                                                                    "".concat(country.name, " (").concat(country.code, ")")
                                                                                ]
                                                                            })
                                                                        }, country.code))
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            country == "India" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                        className: "mb-3",
                                                        as: react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
                                                        lg: "6",
                                                        controlId: "validationCustom01",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                                children: "State"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Select */ .Z.Select, {
                                                                "aria-label": "Default select example",
                                                                value: state,
                                                                onChange: (e)=>setState(e.target.value),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                        value: "",
                                                                        children: "State"
                                                                    }),
                                                                    indianStates.sort().map((cur, inn)=>{
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                            value: cur,
                                                                            children: cur
                                                                        }, inn);
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                        className: "mb-3",
                                                        as: react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
                                                        lg: "6",
                                                        controlId: "validationCustom02",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                                children: "City"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                                type: "text",
                                                                placeholder: "Your City",
                                                                value: city,
                                                                onChange: (e)=>setCity(e.target.value)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                        className: "mb-3",
                                                        as: react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
                                                        lg: "6",
                                                        controlId: "validationCustom01",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                                children: "Subject"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Select */ .Z.Select, {
                                                                "aria-label": "Default select example",
                                                                value: subject,
                                                                onChange: (e)=>setSubject(e.target.value),
                                                                required: true,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                        value: "",
                                                                        children: "Select Your Enquiry"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                        value: "Home",
                                                                        children: "Home"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                        value: "Commercial/Business",
                                                                        children: "Commercial/Business"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                        value: "Others",
                                                                        children: "Others"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                        className: "mb-3",
                                                        as: react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
                                                        lg: "6",
                                                        controlId: "validationCustom02",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                                children: "Email"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                                type: "email",
                                                                placeholder: "Email:",
                                                                value: email,
                                                                onChange: (e)=>setEmail(e.target.value),
                                                                required: true
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                            children: "Message"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                            as: "textarea",
                                                            placeholder: "Your Message",
                                                            style: {
                                                                height: "100px"
                                                            },
                                                            value: message,
                                                            onChange: (e)=>setMessage(e.target.value),
                                                            required: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "contactus_bottom_form",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Check */ .Z.Check, {
                                                            label: "I abide by the Orientbell Privacy Policy",
                                                            feedback: "You must agree before submitting.",
                                                            feedbackType: "invalid",
                                                            required: true
                                                        })
                                                    }),
                                                    loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                        variant: "secondary",
                                                        children: "Submitting"
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                        type: "submit",
                                                        variant: "primary",
                                                        children: "Submit"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "contactus_data_con",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                children: "Corporate Office"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                "Iris House, 16 Business Centre, Nangal Raya, DDA",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                "Complex, New Delhi – 110046 (India)CIN:",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                "L14101UP1977PLC021546",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                "Call Toll Free: 1800 208 1015"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                            src: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14010.547172741708!2d77.109074!3d28.610671!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1cacbfffffff%3A0x9bb8058abbee3f44!2sOrientbell%20Tiles%20Corporate%20Office!5e0!3m2!1sen!2sin!4v1688019901499!5m2!1sen!2sin",
                                            width: "100%",
                                            height: "auto"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Contact);


/***/ }),

/***/ 52681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15094);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const Breadcrumb = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  listProps = {},
  children,
  label = 'breadcrumb',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ol", {
      ...listProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Breadcrumb, {
  Item: _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
}));

/***/ }),

/***/ 15094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13551);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const BreadcrumbItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  active = false,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  linkProps = {},
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LinkComponent, {
      ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);

/***/ }),

/***/ 10682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 34051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7361,7767,5518,7615,6737,6532,5469,3372,9774,2888,179], function() { return __webpack_exec__(86008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);